import React from "react";
import "./PotraitCard.css";
import Button from "../../components/Button/Button";
//import { Globals } from "../../global/Globals";
import { useLanguage } from "../../context/Languagecontext";

const PotraitCard = (props) => {
   const { Globals } = useLanguage();
  const date = new Date(props.data.closingDate);
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0];

  const dateformat = (datestring) => {
    const date = new Date(datestring);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const channelName = props.data?.channelName?.replace(/[\s-&]/g, "");
  const channelLogoSrc = Globals.CHANNEL_LOGO[channelName?.toUpperCase()];
  const globalChannelname=Globals.CHANNEL_NAME[channelName?.toUpperCase()];

  const checkIfDateIsNearExpiration = (expirationDate) => {
    const currentDate = new Date();
    const expiration = new Date(expirationDate);

    currentDate.setHours(0, 0, 0, 0);
    expiration.setHours(0, 0, 0, 0);

    const timeDifference = expiration - currentDate;
    const daysRemaining = timeDifference / (1000 * 3600 * 24);

    // Check if the expiration date is within 3 days from today
    return daysRemaining >= 0 && daysRemaining < 3;
  };

  const isNearExpiration = checkIfDateIsNearExpiration(dateString);
  const expirationClass = isNearExpiration ? "near-expiration" : "";

  return (
    <>
      <div class="potraitcard_Card">
        <div class="potraitcard_cardheader">
          <div class="potraitcard_logo">
            <img src={channelLogoSrc ? channelLogoSrc : Globals.DEFAULTCHANNELLOGO} />
          </div>
          <div class="potraitcard_title">
            <div class="potraitcard_title-heading" title={props.data.channelName}>
              {globalChannelname}
            </div>
            <div class="potraitcard_title-subtitle" title={props.data.formatName}>
              {props.data.formatName}
            </div>
          </div>
        </div>

        <div class="potraitcard_details">
          <div className="potraitcard_detail-header Brief">
            <div className="potraitcard_detail-title">
              {Globals.Dashboard_Brief_card_Heading_BriefNo}
            </div>{" "}
            <div className="potraitcard_detail-value" title={props.data.bRefNo}>
              {props.data.bRefNo}
            </div>
          </div>
          <div className="potraitcard_seperator"></div>
          <div className="potraitcard_detail-header type">
            <div className="potraitcard_detail-title">
              {Globals.Dashboard_Brief_card_Heading_Type}
            </div>{" "}
            <div className="potraitcard_detail-value" title={props.data.productionTypeName}>
              {props.data.productionTypeName}
            </div>
          </div>
          <div className="potraitcard_seperator"></div>
          <div className="potraitcard_detail-header format">
            <div className="potraitcard_detail-title">
              {Globals.Dashboard_Brief_card_Heading_Format}
            </div>{" "}
            <div className="potraitcard_detail-value" title={props.data.formatName}>
              {props.data.formatName}
            </div>
          </div>
          <div className="potraitcard_seperator"></div>
          <div className="potraitcard_detail-header genre">
            <div className="potraitcard_detail-title">
              {Globals.Dashboard_Brief_card_Heading_Genre}
            </div>{" "}
            <div className="potraitcard_detail-value" title={props.data.genreName}>
              {props.data.genreName}
            </div>
          </div>
          <div className="potraitcard_seperator"></div>
          <div className="potraitcard_detail-header language">
            <div className="potraitcard_detail-title">
              {Globals.Dashboard_Brief_card_Heading_Language}
            </div>{" "}
            <div className="potraitcard_detail-value" title={props.data.languageName}>
              {props.data.languageName}
            </div>
          </div>
          <div className="potraitcard_seperator"></div>
          <div className="potraitcard_detail-header closing_date_potraitcard">
            <div className="potraitcard_detail-title">
              {Globals.Dashboard_Brief_card_Heading_Closing_Date}
            </div>{" "}
            <div className={`potraitcard_detail-value ${expirationClass}`} title={dateString}>
              {dateformat(dateString)}
            </div>
          </div>
        </div>

        <Button
          title={Globals.PRODUCER.VIEWAPPLY}
          additionalStyle="apply-buttonPottraitcard"
          action={() => {
            props.togglePopup(props.data);
          }}
          id="Apply-Button"
        />
      </div>
    </>
  );
};

export default PotraitCard;
